import TaskManagerEditDto from './TaskManagerEditDto';

export class PiMeasurementReaderTaskEditDto extends TaskManagerEditDto {
	constructor() {
		super();

		/** @type {string} */
		this.scheduleString = null;

		/** @type {number} */
		this.measurementId = null;

		/** @type {number} */
		this.readerId = null;

		/** @type {number} */
		this.unitOptimizer = null;

		/** @type {number} */
		this.summaryDuration = null;

		/** @type {string} */
		this.summaryDurationUnit = null;

		/** @type {string} */
		this.summaryType = null;
	}

	/**
	 * @typedef {Object} _PiMeasurementReaderTaskEditDtoProps
	 * @property {string} scheduleString
	 * @property {number} measurementId
	 * @property {number} readerId
	 * @property {number} unitOptimizer
	 * @property {number} summaryDuration
	 * @property {string} summaryDurationUnit
	 * @property {string} summaryType
	 *
	 * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _PiMeasurementReaderTaskEditDtoProps} PiMeasurementReaderTaskEditDtoProps
	 */
	/**
	 *
	 * @param {PiMeasurementReaderTaskEditDtoProps} props
	 * @returns {PiMeasurementReaderTaskEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.scheduleString = props.scheduleString;
		this.measurementId = props.measurementId;
		this.readerId = props.readerId;
		this.unitOptimizer = props.unitOptimizer;
		this.summaryDuration = props.summaryDuration;
		this.summaryDurationUnit = props.summaryDurationUnit;
		this.summaryType = props.summaryType;

		return this;
	}
}

export default PiMeasurementReaderTaskEditDto;